import React, {useEffect, useState} from 'react'

import {useDispatch} from 'react-redux'
import {fetchUser} from '../../redux/modules/user'

import ButtonYapp from '../../Components/Buttons/ButtonYapp'
import {_formatRut, _validateRut, _validateMail} from '../../Utils/tools'
import {useHistory} from 'react-router'

import {
  registerPassword,
  resetPassword,
  registerUser,
  _getCurrentUser,
  getMaskEmail,
} from '../../Utils/auth'
import {usedProfessional, validProfessional} from '../../Utils/api'
import {
  sendDoctorValidationEmail,
  sendReportAccountEmail,
} from '../../Utils/emails'
import {logEvent, setUserProperties} from '../../Utils/utils'


import Input from '../../Components/Forms/Input'
import icYappPpproved from '../../assets/img/ic_yapp_approved.svg'
import icCotizadorMedicamentos from '../../assets/img/ic_cotizador_medicamentos.svg'
import icPogramaPacientes from '../../assets/img/ic_pograma_pacientes.svg'
import icInteraccionesMedicamentosa from '../../assets/img/interacciones_medicamentosa.svg'
import imgEresMedico from '../../assets/img/img_eres_medico.svg'
import imgAhorroYapp from '../../assets/img/img_ahorro_yapp.svg'
import imgCotizadorMedicamentos from '../../assets/img/img_cotizador_medicamentos.svg'
import imgProgramaPaciente from '../../assets/img/img_programa_paciente.svg'
import imgInteracionesMedicamentosas from '../../assets/img/img_interaciones_medicamentosas.svg'

import ModalRegiteredRut from '../../Components/Modals/ModalRegiteredRut'
import ModalFailValidate from '../../Components/Modals/ModalFailValidate'
import ModalAccountRegistered from '../../Components/Modals/ModalAccountRegistered'
import ModalError from '../../Components/Modals/ModalError'

function NewRegisterPro() {
  const history = useHistory()
  const dispatch = useDispatch()

  const [step, setStep] = useState(1)
  const [rut, setRut] = useState()
  const [email, setEmail] = useState('')
  const [userName, setUserName] = useState('')
  const [password, setPassword] = useState('')
  const [passwordConfirmation, setPasswordConfirmation] = useState('')
  const [validRut, setValidRut] = useState(false)
  const [policies, setPolicies] = useState(false)
  const [buttonDisable, setButtonDisable] = useState(true)

  const [modalFailValidateState, setModalFailValidateState] = useState(false)
  const [modalRegisteredRutState, setModalRegisteredRutState] = useState(false)
  const [modalAccountExistError, setModalAccountExistError] = useState(false)
  const [modalAccountError, setModalAccountError] = useState(false)

  const onChangeIdentity = (value) => {
    let format = _formatRut(value)
    let rutValidation = _validateRut(value)
    setRut(format || value)
    setValidRut(rutValidation)
    setButtonDisable(!rutValidation)
  }

  const validateUser = async () => {
    setButtonDisable(true)
    const result = await usedProfessional(rut)
    let data = result?.data?.length > 0 ? result?.data[0] : null
    let validated = data?.status === 'available'
      ? 'True'
      : 'False'
    let status = data?.status === 'available'
      ? 'Available'
      : data?.status === 'used'
        ? 'Used'
        : 'Failured'

    logEvent('Account Validated', {
      'Status': status,
      'Validated': validated
    })
    if (data?.status === 'available') {
      setStep(2)
    } else if (data?.status === 'used') {
      setModalRegisteredRutState(true)
    } else {

      setModalFailValidateState(true)
    }
    setButtonDisable(false)
  }

  const validateUserInfo = async () => {
    setButtonDisable(true)
    if (_validateMail(email)) {
      const provider = 'email'
      let identityDocument = ''
      let nameArray = userName.split(' ')
      let response = await registerPassword(
        email,
        password,
        nameArray[0],
        nameArray[1],
      )


      if (response.status === 'already-account') {
        setModalAccountExistError(true)
      } else if (response.status === 'success') {
        return registerUserInfo(
          provider,
          nameArray[0],
          nameArray[1],
          identityDocument,
        )

      } else {
        setModalAccountError(true)
      }
    }
    setButtonDisable(false)
  }
  const registerUserInfo = async (
    provider,
    firstName,
    lastName,
    identityDocument,
  ) => {

    await dispatch(fetchUser())
    let currentUser = JSON.parse(localStorage.getItem('login_temp_data'))
    let response = await registerUser(
      email,
      password,
      firstName,
      lastName,
      rut,
      identityDocument,
      policies,
      currentUser,
    )

    if (response) {
      await validProfessional(rut, currentUser?.profile?.uid)
      logEvent('Create Account Completed', {
        'Account Type': provider,
        'Account Created': true,
      })
      goTo('home')
    } else {

      setModalAccountError(true)
    }
    setButtonDisable(false)
  }

  const retryValidation = () => {
    setModalFailValidateState(false)
    validateUser()
  }

  const validUserInfo = () => {
    return !(
      policies &&
      validRut &&
      _validateMail(email) &&
      userName?.length > 2 &&
      password?.length > 7 &&
      password === passwordConfirmation

    )
  }

  const handleDoctorValidationEmail = async (email) => {
    try {
      const result = await sendDoctorValidationEmail(rut, email)
      return result.status === 204 ? true : false
    } catch (error) {
      return false
    }
  }

  const handleReportAccountEmail = async (email) => {
    try {
      const result = await sendReportAccountEmail(email)
      return result.status === 204 ? true : false
    } catch (error) {
      return false
    }
  }

  function goTo(page) {
    if (page === 'policies') {
      return window.open('https://yapp.cl/privacidad')
    }
    if (page === 'terms') {
      return window.open('https://yapp.cl/terminos')
    }
    if (page === 'home') {
      return history.push('/pro/menu')
    }
    if (page === 'login') {
      return history.push('/signin', {requiredValidate: true})
    }
  }

  return (
    <div>
      <div className="section-one px-3 px-lg-0">
        <div
          className="content-responsive-1021 bg-content-landing-top py-5 mb-4 d-flex flex-column align-items-center flex-lg-row justify-content-between"
          style={{
            backgroundImage: `url(${imgEresMedico})`,
            backgroundPositionX: '301px',
            backgroundRepeat: 'no-repeat',
            backgroundPositionY: '80px',
          }}>
          <div className="maxw-390 mr-auto mb-4">
            <h3 className="txt-1--bold m-0">¿Eres médico?</h3>
            <h3 className="txt-1--bold m-0 mb-3">¡Te damos la bienvenida!</h3>
            <p className="txt-3--light m-0 mb-2">
              Comparte los convenios Yapp con tus pacientes y ayúdalos a ahorrar
              en sus tratamientos.
            </p>
            <p className="txt-3--light m-0">
              Tenemos medicamentos desde un 25% de descuento.
            </p>
            <div className="content-menu-pro-landing">
              <a className="menu-pro" href="#convenio" role="">
                <img
                  height="30"
                  src={icYappPpproved}
                  alt="Convenio Yapp"
                  className="icon-menu"
                />
                <p className="txt-4--bold-db">Convenio Yapp</p>
              </a>
              <a className="menu-pro" href="#cotizador" role="">
                <img
                  height="30"
                  src={icCotizadorMedicamentos}
                  alt="Convenio Yapp"
                  className="icon-menu"
                />
                <p className="txt-4--bold-db">Cotizador de medicamentos</p>
              </a>
              <a className="menu-pro" href="#programa" role="">
                <img
                  height="30"
                  src={icPogramaPacientes}
                  alt="Convenio Yapp"
                  className="icon-menu"
                />
                <p className="txt-4--bold-db">Programas de paciente</p>
              </a>
              <a className="menu-pro" href="#interacciones" role="">
                <img
                  height="30"
                  src={icInteraccionesMedicamentosa}
                  alt="Convenio Yapp"
                  className="icon-menu"
                />
                <p className="txt-4--bold-db">Interacciones medicamentosas</p>
              </a>
            </div>
          </div>
          <div className="content-form-register-pro" id="unete">
            {step === 1 && (

              <div className="content-form-register-pro-spaces">
                <h4 className="txt-4--bold m-0 mb-3">
                  Para acceder debemos validarte como médico
                </h4>
                <div className="mb-3">
                  <Input
                    id="gtm-webapp-rut-validate"
                    error={
                      !validRut && rut?.length > 0 && {message: '*rut inválido'}
                    }
                    label="Ingresa tu RUT"
                    placeholder="Ingresa tu RUT"
                    value={rut || ''}
                    doChange={(value) => onChangeIdentity(value)}
                  />
                </div>
                <ButtonYapp
                  title="Validarme como médico"
                  className="w-100 mb-3"
                  disabled={buttonDisable}
                  onClick={validateUser}

                />
                <p className="txt-5--regular  text-center">
                  Para validar si eres médico, utilizamos la base de datos de la
                  Superintendencia de Salud.
                </p>
                <div className="d-flex align-items-center mt-3">
                  <div className="txt-2--bold-db">¿Ya tienes una cuenta?</div>
                  <div
                    className="txt-2--bold-pr m-0 ml-2 c-pointer"
                    onClick={() => goTo('login')}>
                    Inicia Sesión
                  </div>
                </div>
              </div>
            )}
            {step === 2 && (

              <div>
                <h4 className="txt-4--bold m-0 mb-2">Crear una cuenta</h4>
                <div>
                  <div className="mb-2">
                    <Input
                      id="gtm-webapp-email-register"
                      error={false && {message: '*Correo inválido'}}
                      label="Correo"
                      placeholder="Correo"
                      value={email || ''}
                      doChange={(email) => setEmail(email)}
                    />
                  </div>
                  <div className="mb-2">
                    <Input
                      id="gtm-webapp-name-register"
                      error={false && {message: '*Nombre inválido'}}
                      label="Nombre y apellido"
                      placeholder="Nombre y apellido"
                      value={userName || ''}
                      doChange={(name) => setUserName(name)}
                    />
                  </div>
                  <div className="mb-2">
                    <Input
                      id="gtm-webapp-rut-register"
                      label="RUT"
                      placeholder="RUT"
                      value={rut || ''}
                    />
                  </div>
                  <div className="w-100 mb-2">
                    <Input
                      id={'gtm-webapp-register-pass'}
                      showPass
                      label="Contraseña"
                      error={{message: ''}}
                      doChange={(password) => setPassword(password)}
                    />
                    <p className="txt-6--regular-g1 ml-3 mb-1 mt-2">
                      *Tu contraseña debe tener un mínimo de 8 caracteres.
                    </p>
                  </div>
                  <div className="w-100 mb-2">
                    <Input
                      id={'gtm-webapp-register-repeat-pass'}
                      showPass
                      label="Repetir contraseña"
                      error={
                        password?.length > 7 &&
                        password !== passwordConfirmation
                          ? {message: '*Tu contraseña no coincide.'}
                          : ''

                      }
                      doChange={(password) => setPasswordConfirmation(password)}
                    />
                  </div>
                  <div className="d-flex align-items-center mb-4 mt-3">
                    <label
                      className="custom-checkbox-altern align-items-start pl-4 m-0"
                      id={'gtm-webapp-register-check-terms'}>
                      <input
                        id="gtm-webapp-register-checkbox"
                        ref={null}
                        disabled={false}
                        type="checkbox"
                        onChange={(evt) => setPolicies(evt.target.checked)}
                      />
                      <span className="checkmark-altern">
                        <i
                          id="gtm-webapp-register-checkbox-icon"
                          className="icon-checkmark"
                        />

                      </span>
                    </label>
                    <span className="txt-5--regular-db ml-2 line-16">
                      Acepto los{' '}
                      <span
                        id="gtm-webapp-register-terms"
                        className="txt-5--regular-pr c-pointer"
                        onClick={() => goTo('terms')}>
                        Términos & Condiciones
                      </span>{' '}
                      y{' '}
                      <span
                        id="gtm-webapp-register-policies"
                        className="txt-5--regular-pr c-pointer"
                        onClick={() => goTo('policies')}>
                        Políticas de privacidad
                      </span>
                    </span>
                  </div>
                  <ButtonYapp
                    disabled={buttonDisable || validUserInfo()}
                    id={'gtm-webapp-register-btn'}
                    className="btn-default--small btn-default font--14 size-content-responsive-btn mx-auto w-100 mb-4"
                    onClick={validateUserInfo}

                    title={'Crear cuenta'}
                  />

                  <h3 className="txt-5--regular-db text-center w-100">
                    ¿Ya tienes una cuenta en Yapp?{' '}
                    <span
                      id={'gtm-webapp-register-login-btn'}
                      className="txt-4--bold-pr c-pointer"
                      onClick={() => goTo('login')}>
                      Iniciar sesión
                    </span>
                  </h3>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="section-two px-3 px-lg-0" id="convenio">
        <div className="content-responsive-1021 py-5 mb-4 d-flex flex-column align-items-center flex-lg-row justify-content-between">
          <div className="d-flex flex-column justify-content-center mb-4">
            <h3 className="txt-1--bold m-0 mb-2">Convenio Yapp</h3>
            <p className="txt-2--regular m-0 mb-4 maxw-500">
              Este beneficio exclusivo para médicos te permitirá apoyar a tus
              pacientes a través de descuentos en sus tratamientos. Comparte tu
              código y ayúdalos a mantenerse adheridos. Descuentos desde 25%.
            </p>
            <div className="d-flex justify-content-lg-start justify-content-center">
              <a href="#unete">
                <ButtonYapp title="Únete a Yapp" stroke className="maxw-180" />

              </a>
            </div>
          </div>
          <div className="d-flex align-items-center">
            <img src={imgAhorroYapp} alt="Convenio Yapp" className="w-100" />
          </div>
        </div>
      </div>
      <div className="section-three px-3 px-lg-0" id="cotizador">
        <div className="content-responsive-1021 py-5 mb-4 d-flex flex-column align-items-center flex-lg-row justify-content-between">
          <div className="d-flex flex-column justify-content-center mb-4">
            <h3 className="txt-1--bold m-0 mb-2">Cotizador de medicamentos</h3>
            <p className="txt-2--regular m-0 mb-4 maxw-500">
              Cotiza los medicamentos en farmacias para orientar a tus pacientes
              sobre el costo del tratamiento. También tenemos más de 10
              farmacias con despacho a todo Chile
            </p>
            <div className="d-flex justify-content-lg-start justify-content-center">
              <a href="#unete">
                <ButtonYapp title="Únete a Yapp" stroke className="maxw-180" />
              </a>
            </div>
          </div>
          <div className="d-flex align-items-center">
            <img
              src={imgCotizadorMedicamentos}
              alt="Convenio Yapp"
              className="w-100"
            />
          </div>
        </div>
      </div>
      <div className="section-four px-3 px-lg-0" id="programa">
        <div className="content-responsive-1021 py-5 mb-4 d-flex flex-column align-items-center flex-lg-row justify-content-between">
          <div className="d-flex align-items-center order-2 order-lg-1">
            <img
              src={imgProgramaPaciente}
              alt="Programas de paciente"
              className="w-100"
            />
          </div>
          <div className="d-flex flex-column justify-content-center order-1 order-lg-2 mb-4">
            <h3 className="txt-1--bold m-0 mb-2">Programas de paciente</h3>
            <p className="txt-2--regular m-0 mb-4 maxw-500">
              Ayuda a tus pacientes a obtener beneficios en sus tratamientos.
              Conoce todas las alternativas de Programas disponibles para tus
              pacientes.
            </p>
            <div className="d-flex justify-content-lg-start justify-content-center">
              <a href="#unete">
                <ButtonYapp title="Únete a Yapp" stroke className="maxw-180" />

              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="section-five px-3 px-lg-0" id="interacciones">
        <div className="content-responsive-1021 py-5 mb-4 d-flex flex-column align-items-center flex-lg-row justify-content-between">
          <div className="d-flex flex-column justify-content-center mb-4">
            <h3 className="txt-1--bold m-0 mb-2">
              Interacciones medicamentosas
            </h3>
            <p className="txt-2--regular m-0 mb-4 maxw-500">
              Evalúa las posibles interacciones entre dos o más medicamentos
              antes de prescribir.
            </p>
            <div className="d-flex justify-content-lg-start justify-content-center">
              <a href="#unete">
                <ButtonYapp title="Únete a Yapp" stroke className="maxw-180" />
              </a>
            </div>
          </div>
          <div className="d-flex align-items-center ">
            <img
              src={imgInteracionesMedicamentosas}
              alt="Interacciones medicamentosas"
              className="w-100"
            />
          </div>
        </div>
      </div>
      <ModalRegiteredRut
        modalRegisteredRutState={modalRegisteredRutState}
        email={email}
        setModalRegisteredRutState={setModalRegisteredRutState}
        resetPassword={() => resetPassword(email)}
        sendEmail={(email) => handleReportAccountEmail(email)}
      />
      <ModalFailValidate
        modalFailValidateState={modalFailValidateState}
        setModalFailValidateState={setModalFailValidateState}
        sendEmail={(email) => handleDoctorValidationEmail(email)}
        retry={retryValidation}
      />
      <ModalAccountRegistered
        modalAccountR={modalAccountExistError}
        setModalAccountR={setModalAccountExistError}
        onSignIn={() => goTo('login')}
      />
      <ModalError
        isOpen={modalAccountError}
        setIsOpen={setModalAccountError}
        imgName="icErrorServer"
        title="¡Ups!"
        text="No hemos podido crear tu cuenta"
        btnText="Volver a intentar"
        className="mx-4"
      />
    </div>
  )
}

export default NewRegisterPro
